import { circles } from './circles.style';
import { polygonStyle } from './polygon.style';
import { drawHelperMovingLayerStyle } from './drawHelper.style';
import { lineStyle } from './line.style';

export const drawStyle = [...polygonStyle, ...lineStyle, ...circles, ...drawHelperMovingLayerStyle];
